module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "parent project_item--display-testimony"
  }, [_c('article', {
    staticClass: "container"
  }, [_c('header', [_c('h1', [_vm._v(_vm._s(_vm.msg))])]), _vm._v(" "), (_vm.items && _vm.items.length) ? _c('ul', _vm._l((_vm.items), function(item) {
    return _c('li', [(item.testimonial[0].quote) ? [_c('h2', [_vm._v(_vm._s(item.client))]), _vm._v(" "), _c('project-testimonial', {
      attrs: {
        "id": item.id,
        "link": item.testimonial[0].link,
        "quote": item.testimonial[0].quote,
        "name": item.testimonial[0].name,
        "role": item.testimonial[0].role
      }
    })] : void 0], 2)
  }), 0) : _vm._e(), _vm._v(" "), (_vm.errors && _vm.errors.length) ? _c('ul', _vm._l((_vm.errors), function(error) {
    return _c('li', [_vm._v("\n                " + _vm._s(error.message) + "\n            ")])
  }), 0) : _vm._e()])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-06604693"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/partials/testimonials/Testimonials.vue
// module id = 77
// module chunks = 0